import { UserRoles } from 'src/app/core/enums/user-roles.enum';
import { UserAdmin } from 'src/app/core/models/admin/user-admin.model';
import { Items } from 'src/app/core/models/common/items.model';
import { DEFAULT_LANGUAGE } from 'src/app/core/models/languages.model';
import {
  ACTIONS_TEXT,
  IMAGE_SRC,
  STATUS_OPTIONS,
} from '../../shared-constants';

export enum ColumnIds {
  EMPLOYEE_ID = 'employeeId',
  USER_ID = 'loginId',
  LAST_NAME = 'familyName',
  FIRST_NAME = 'givenName',
  LOCATION = 'locationCode',
  LOCATION_GROUP = 'locationGroupCode',
  USER_ROLE = 'roleName',
  EMAIL = 'email',
  LAST_LOGIN = 'lastLoggedIn',
  STATUS = 'enabled',
  ACTION = 'action',
}

export const ColumnText = {
  USER_ID: $localize`User Id`.toUpperCase(),
  EMPLOYEE_ID: $localize`Employee Id`.toUpperCase(),
  LAST_NAME: $localize`Last Name`.toUpperCase(),
  FIRST_NAME: $localize`First Name`.toUpperCase(),
  LOCATION: $localize`Location`.toUpperCase(),
  LOCATION_GROUP: $localize`Location Group`.toUpperCase(),
  USER_ROLE: $localize`User Role`.toUpperCase(),
  EMAIL: $localize`Email`.toUpperCase(),
  LAST_LOGIN: $localize`Last Login`.toUpperCase(),
  STATUS: $localize`Status`.toUpperCase(),
};

export const CONSTS = {
  WELCOME_TEXT: $localize`User Admin`,
  ACTIONS: ACTIONS_TEXT,
  REMOVE_USER_HEADER: $localize`Remove User`,
  REMOVE_USER_TEXT: $localize`Are you sure you want to remove the following user:`,
  NO: $localize`No`,
  YES: $localize`Yes`,
  ADD_USER_HEADER: $localize`Add User`,
  EDIT_USER_HEADER: $localize`Edit User`,
  VIEW_USER_HEADER: $localize`View User`,
  ACTIVE: $localize`Active`.toUpperCase(),
};

export const STATUS_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

export const MOCK_TABLE_CONSTS: UserAdmin[] = [
  {
    version: 123,
    loginId: 'abc1def',
    familyName: 'Herald',
    givenName: 'Zack',
    locationCode: 'PECHT',
    locationId: 4234234,
    locationName: 'PECHT',
    locationGroupCode: 'TEST',
    locationGroupId: 23423948,
    locationGroupName: 'TEST',
    userType: 'H',
    defaultLanguage: DEFAULT_LANGUAGE,
    roleName: UserRoles.GROUPADMIN,
    email: 'flastName@ups.com',
    enabled: false,
    handheldSupervisor: false,
    sciIndicator: 1,
    lastLoggedIn: '2025/12/25',
  },
  {
    version: 234,
    loginId: 'abc2def',
    familyName: 'Garfield',
    givenName: 'Tom',
    locationCode: 'PECHT',
    locationId: 4234234,
    locationName: 'PECHT',
    locationGroupCode: 'TEST',
    locationGroupId: 23423948,
    locationGroupName: 'TEST',
    userType: 'H',
    defaultLanguage: DEFAULT_LANGUAGE,
    roleName: UserRoles.GROUPMANAGER,
    email: 'flastName@ups.com',
    enabled: false,
    handheldSupervisor: false,
    sciIndicator: 1,
    lastLoggedIn: '2025/12/25',
  },
  {
    version: 345,
    loginId: 'abc3def',
    familyName: 'Ali',
    givenName: 'Ali',
    locationCode: 'PECHT',
    locationId: 4234234,
    locationName: 'PECHT',
    locationGroupCode: 'TEST',
    locationGroupId: 23423948,
    locationGroupName: 'TEST',
    userType: 'H',
    defaultLanguage: DEFAULT_LANGUAGE,
    roleName: UserRoles.USER,
    email: 'flastName@ups.com',
    enabled: true,
    handheldSupervisor: true,
    sciIndicator: 1,
    lastLoggedIn: '2025/12/25',
  },
  {
    version: 456,
    loginId: 'abc4def',
    familyName: 'Sanchez',
    givenName: 'Rick',
    locationCode: 'PECHT',
    locationId: 4234234,
    locationName: 'PECHT',
    locationGroupCode: 'TEST',
    locationGroupId: 23423948,
    locationGroupName: 'TEST',
    userType: 'H',
    defaultLanguage: DEFAULT_LANGUAGE,
    roleName: UserRoles.USER,
    email: 'flastName@ups.com',
    enabled: true,
    handheldSupervisor: true,
    sciIndicator: 1,
    lastLoggedIn: '2025/12/25',
  },
  {
    version: 567,
    loginId: 'abc5def',
    familyName: 'Yakov',
    givenName: 'Max',
    locationCode: 'PECHT',
    locationId: 4234234,
    locationName: 'PECHT',
    locationGroupCode: 'TEST',
    locationGroupId: 23423948,
    locationGroupName: 'TEST',
    userType: 'H',
    defaultLanguage: DEFAULT_LANGUAGE,
    roleName: UserRoles.USER,
    email: 'flastName@ups.com',
    enabled: false,
    handheldSupervisor: false,
    sciIndicator: 1,
    lastLoggedIn: '2025/12/25',
  },
  {
    version: 678,
    loginId: 'abc6def',
    familyName: 'Terry',
    givenName: 'Richard',
    locationCode: 'PECHT',
    locationId: 4234234,
    locationName: 'PECHT',
    locationGroupCode: 'TEST',
    locationGroupId: 23423948,
    locationGroupName: 'TEST',
    userType: 'H',
    defaultLanguage: DEFAULT_LANGUAGE,
    roleName: UserRoles.USER,
    email: 'flastName@ups.com',
    enabled: false,
    handheldSupervisor: false,
    sciIndicator: 1,
    lastLoggedIn: '2025/12/25',
  },
  {
    version: 789,
    loginId: 'abc7def',
    familyName: 'Zar',
    givenName: 'Erwin',
    locationCode: 'PECHT',
    locationId: 4234234,
    locationName: 'PECHT',
    locationGroupCode: 'TEST',
    locationGroupId: 23423948,
    locationGroupName: 'TEST',
    userType: 'H',
    defaultLanguage: DEFAULT_LANGUAGE,
    roleName: UserRoles.GROUPADMIN,
    email: 'flastName@ups.com',
    enabled: false,
    handheldSupervisor: false,
    sciIndicator: 1,
    lastLoggedIn: '2025/12/25',
  },
  {
    version: 890,
    loginId: 'abc8def',
    familyName: 'Lee',
    givenName: 'James',
    locationCode: 'PECHT',
    locationId: 4234234,
    locationName: 'PECHT',
    locationGroupCode: 'TEST',
    locationGroupId: 23423948,
    locationGroupName: 'TEST',
    userType: 'H',
    defaultLanguage: DEFAULT_LANGUAGE,
    roleName: UserRoles.ADMIN,
    email: 'flastName@ups.com',
    enabled: true,
    handheldSupervisor: true,
    sciIndicator: 1,
    lastLoggedIn: '2025/12/25',
  },
  {
    version: 321,
    loginId: 'abc9def',
    familyName: 'Tong',
    givenName: 'Mike',
    locationCode: 'PECHT',
    locationId: 4234234,
    locationName: 'PECHT',
    locationGroupCode: 'TEST',
    locationGroupId: 23423948,
    locationGroupName: 'TEST',
    userType: 'H',
    defaultLanguage: DEFAULT_LANGUAGE,
    roleName: UserRoles.ADMIN,
    email: 'flastName@ups.com',
    enabled: true,
    handheldSupervisor: true,
    sciIndicator: 1,
    lastLoggedIn: '2025/12/25',
  },
  {
    version: 432,
    loginId: 'abc0def',
    familyName: 'Jirnov',
    givenName: 'Vlad',
    locationCode: 'PECHT',
    locationId: 4234234,
    locationName: 'PECHT',
    locationGroupCode: 'TEST',
    locationGroupId: 23423948,
    locationGroupName: 'TEST',
    userType: 'H',
    defaultLanguage: DEFAULT_LANGUAGE,
    roleName: UserRoles.USER,
    email: 'flastName@ups.com',
    enabled: true,
    handheldSupervisor: true,
    sciIndicator: 1,
    lastLoggedIn: '2025/12/25',
  },
];

export const EXCEL_FILE_NAME = $localize`user-admin-data`;

export const GLOBAL_ID_FILE_NAME = $localize`global-id-data`;
